import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { Row, Col, Collapse } from "reactstrap";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import classname from "classnames";

//i18n
import { withTranslation } from "react-i18next";

import { connect } from "react-redux";

const Navbar = props => {
  const [ui, setui] = useState(false);

  const [email, setemail] = useState(false);

  const [component, setcomponent] = useState(false);
  const [form, setform] = useState(false);
  const [table, settable] = useState(false);
  const [chart, setchart] = useState(false);
  const [icon, seticon] = useState(false);
  const [map, setmap] = useState(false);
  const [extra, setextra] = useState(false);
  const [auth, setauth] = useState(false);

  useEffect(() => {
    var matchingMenuItem = null;
    var ul = document.getElementById("navigation");
    var items = ul.getElementsByTagName("a");
    removeActivation(items);
    for (var i = 0; i < items.length; ++i) {
      if (window.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  });

  const removeActivation = items => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;
      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        if (parent.classList.contains("active")) {
          parent.classList.remove("active");
        }
      }
    }
  };

  function activateParentDropdown(item) {
    item.classList.add("active");
    const parent = item.parentElement;
    if (parent) {
      parent.classList.add("active"); // li
      const parent2 = parent.parentElement;
      parent2.classList.add("active"); // li
      const parent3 = parent2.parentElement;
      if (parent3) {
        parent3.classList.add("active"); // li
        const parent4 = parent3.parentElement;
        if (parent4) {
          parent4.classList.add("active"); // li
          const parent5 = parent4.parentElement;
          if (parent5) {
            parent5.classList.add("active"); // li
            const parent6 = parent5.parentElement;
            if (parent6) {
              parent6.classList.add("active"); // li
            }
          }
        }
      }
    }
    return false;
  }

  return (
    <React.Fragment>
      <div className="topnav">
        <div className="container-fluid">
          <nav
            className="navbar navbar-light navbar-expand-lg topnav-menu"
            id="navigation"
          >
            <Collapse
              isOpen={props.leftMenu}
              className="navbar-collapse"
              id="topnav-menu-content"
            >
              <ul className="navbar-nav">
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/dashboard"
                  >
                    <i className="ti-home me-2" />
                    {props.t("Dashboard")} {props.menuOpen}
                  </Link>

                </li>

                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/bookings"
                  >
                    <i className="ti-calendar me-2" />
                    {props.t("Bookings")} {props.menuOpen}
                  </Link>

                </li>

                <li className="nav-item dropdown mega-dropdown">
                  <Link
                    to="/#"
                    onClick={e => {
                      e.preventDefault();
                      setui(!ui);
                    }}
                    className="nav-link dropdown-toggle arrow-none"
                  >
                    <i className="ti-user me-2"></i>
                    {props.t("Users")}
                  </Link>
                  <div
                    className={classname(
                      "dropdown-menu mega-dropdown-menu px-2 dropdown-menu-start dropdown-mega-menu-md",
                      { show: ui }
                    )}
                  >
                    <Row>
                      <Col lg={12}>
                        <div>
                          <Link to="/drivers" className="dropdown-item">
                            {props.t("Drivers")}
                          </Link>
                          <Link to="/customers" className="dropdown-item">
                            {props.t("Customers")}
                          </Link>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </li>

                <li className="nav-item dropdown mega-dropdown">
                  <Link
                    to="/#"
                    onClick={e => {
                      e.preventDefault();
                      setui(!ui);
                    }}
                    className="nav-link dropdown-toggle arrow-none"
                  >
                    <i className="ti-user me-2"></i>
                    {props.t("Vehicles")}
                  </Link>
                  <div
                    className={classname(
                      "dropdown-menu mega-dropdown-menu px-2 dropdown-menu-start dropdown-mega-menu-md",
                      { show: ui }
                    )}
                  >
                    <Row>
                      <Col lg={12}>
                        <div>
                          <Link to="/vehicles" className="dropdown-item">
                            {props.t("All Vehicles")}
                          </Link>
                          <Link to="/vehicles-categories" className="dropdown-item">
                            {props.t("Vehicle Categories")}
                          </Link>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </li>

                <li className="nav-item dropdown">
                  <Link
                    to="/#"
                    className="nav-link dropdown-toggle arrow-none"
                    onClick={e => {
                      e.preventDefault();
                      setcomponent(!component);
                    }}
                  >
                    <i className="ti-printer me-2"></i>
                    {props.t("Documents")}
                  </Link>
                  <div
                    className={classname("dropdown-menu", { show: component })}
                  >
                    <div className="dropdown">
                      <Link
                        to="/#"
                        className="dropdown-item dropdown-toggle arrow-none"
                        onClick={e => {
                          e.preventDefault();
                          setemail(!email);
                        }}
                      >
                        {props.t("Driver Documents")} <div className="arrow-down"></div>
                      </Link>
                      <div
                        className={classname("dropdown-menu", { show: email })}
                      >
                        <Link to="/drivers-documents-types" className="dropdown-item">
                          {props.t("Document Types (Driver)")}
                        </Link>
                        <Link to="/drivers-documents" className="dropdown-item">
                          {props.t("Uploaded Documents (Driver)")}
                        </Link>
                      </div>
                    </div>
                    <div className="dropdown">
                      <Link
                        to="/#"
                        className="dropdown-item dropdown-toggle arrow-none"
                        onClick={e => {
                          e.preventDefault();
                          setform(!form);
                        }}
                      >
                        {props.t("Vehicle Documents")} <div className="arrow-down"></div>
                      </Link>
                      <div
                        className={classname("dropdown-menu", { show: form })}
                      >
                        <Link to="/vehicles-documents-types" className="dropdown-item">
                          {props.t("Document Types (Vehicle)")}
                        </Link>
                        <Link to="/vehicles-documents" className="dropdown-item">
                          {props.t("Uploaded Documents (Vehicle)")}
                        </Link>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="nav-item dropdown mega-dropdown">
                  <Link
                    to="/#"
                    onClick={e => {
                      e.preventDefault();
                      setui(!ui);
                    }}
                    className="nav-link dropdown-toggle arrow-none"
                  >
                    <i className="ti-wallet me-2"></i>
                    {props.t("Payments")}
                  </Link>
                  <div
                    className={classname(
                      "dropdown-menu mega-dropdown-menu px-2 dropdown-menu-start dropdown-mega-menu-md",
                      { show: ui }
                    )}
                  >
                    <Row>
                      <Col lg={12}>
                        <div>
                          <Link to="/#" className="dropdown-item">
                            {props.t("User Wallets")}
                          </Link>
                          <Link to="/#" className="dropdown-item">
                            {props.t("Wallet Transactions")}
                          </Link>
                          <Link to="/#" className="dropdown-item">
                            {props.t("Anees Voucher Top-Up")}
                          </Link>
                          <Link to="/#" className="dropdown-item">
                            {props.t("Driver Top-Up History")}
                          </Link>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </li>

                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/materials"
                  >
                    <i className="ti-home me-2" />
                    {props.t("Materials")} {props.menuOpen}
                  </Link>
                </li>

                <li className="nav-item dropdown mega-dropdown">
                  <Link
                    to="/#"
                    onClick={e => {
                      e.preventDefault();
                      setui(!ui);
                    }}
                    className="nav-link dropdown-toggle arrow-none"
                  >
                    <i className="ti-gift me-2"></i>
                    {props.t("Offers")}
                  </Link>
                  <div
                    className={classname(
                      "dropdown-menu mega-dropdown-menu px-2 dropdown-menu-start dropdown-mega-menu-md",
                      { show: ui }
                    )}
                  >
                    <Row>
                      <Col lg={12}>
                        <div>
                          <Link to="/#" className="dropdown-item">
                            {props.t("Active Deals")}
                          </Link>
                          <Link to="/#" className="dropdown-item">
                            {props.t("Promo Codes")}
                          </Link>
                          <Link to="/#" className="dropdown-item">
                            {props.t("Discounts")}
                          </Link>
                          <Link to="/#" className="dropdown-item">
                            {props.t("Referral Programs")}
                          </Link>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </li>

                <li className="nav-item dropdown mega-dropdown">
                  <Link
                    to="/#"
                    onClick={e => {
                      e.preventDefault();
                      setui(!ui);
                    }}
                    className="nav-link dropdown-toggle arrow-none"
                  >
                    <i className="ti-headphone-alt me-2"></i>
                    {props.t("Support")}
                  </Link>
                  <div
                    className={classname(
                      "dropdown-menu mega-dropdown-menu px-2 dropdown-menu-start dropdown-mega-menu-md",
                      { show: ui }
                    )}
                  >
                    <Row>
                      <Col lg={12}>
                        <div>
                          <Link to="/#" className="dropdown-item">
                            {props.t("Contact Admin")}
                          </Link>
                          <Link to="/#" className="dropdown-item">
                            {props.t("FAQs")}
                          </Link>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </li>

              </ul>
            </Collapse>
          </nav>
        </div>
      </div>
    </React.Fragment>
  );
};

Navbar.propTypes = {
  leftMenu: PropTypes.any,
  location: PropTypes.any,
  menuOpen: PropTypes.any,
  t: PropTypes.any,
};

const mapStatetoProps = state => {
  const { leftMenu } = state.Layout;
  return { leftMenu };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(Navbar))
);
